import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { StyleSheet, Text } from 'react-native';
import CommonStyles from 'common/CommonStyles';
import CommonBridge from 'common/CommonBridge';

const { ScaleFontSize, ScaleLineHeight } = CommonStyles;

const styles = StyleSheet.create({
  wrapper: {
    zIndex: 10000,
    backgroundColor: 'rgba(0,0,0,.65)',
    color: '#ffffff',
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    paddingBottom: 4,
    position: 'absolute',
    left: '50%',
    bottom: '50%',
    fontSize: ScaleFontSize(14),
    lineHeight: ScaleLineHeight(18),
    borderRadius: 2,
    transform: [{ translateX: '-50%' }],
  },
});

const ToastContainer = React.memo(({ message }) => {
  let el;
  const isWeb = CommonBridge.isWeb();
  if (isWeb) {
    el = document.createElement('div');
    document.body.appendChild(el);
  }

  useEffect(() => {
    return () => {
      if (isWeb && el) {
        document.body.removeChild(el);
      }
    };
  }, [message]);

  if (!el) {
    return null;
  } else {
    return isWeb ? (
      createPortal(<Text style={styles.wrapper}>{message}</Text>, el)
    ) : (
      <Text style={styles.wrapper}>{message}</Text>
    );
  }
});

export default ToastContainer;
